'use client';

import { c as _c } from "react/compiler-runtime";
import type { JSX } from 'react';
import { useAfterPaint } from './motion-hooks';
import { cn } from '@/lib/utils';
const DIGITS = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

/**
 * An odometer for a count: each digit rolls to its new value. Inherits the
 * surrounding font size and colour, so it drops into text like
 * `+<RollingNumber value={additions} startFromZero={false} />`.
 */
export function RollingNumber(t0) {
  const $ = _c(14);
  const {
    value,
    startFromZero,
    className
  } = t0;
  const painted = useAfterPaint();
  const rolled = painted || !startFromZero;
  let t1;
  if ($[0] !== value) {
    t1 = Math.round(value);
    $[0] = value;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const count = String(Math.max(0, t1));
  let t2;
  if ($[2] !== className || $[3] !== count || $[4] !== rolled) {
    let t3;
    if ($[6] !== count.length) {
      t3 = (digit, index) => ({
        digit,
        place: count.length - index
      });
      $[6] = count.length;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    const columns = count.split("").map(t3);
    let t4;
    if ($[8] !== className) {
      t4 = cn("inline-flex h-[1em] overflow-clip leading-[1em] tabular-nums", className);
      $[8] = className;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    let t5;
    if ($[10] !== count) {
      t5 = <span className="sr-only">{count}</span>;
      $[10] = count;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    let t6;
    if ($[12] !== rolled) {
      t6 = t7 => {
        const {
          digit: digit_0,
          place
        } = t7;
        return <span key={place} aria-hidden="true" className="inline-block h-[1em] overflow-clip align-top"><span className="block transition-transform duration-500 ease-[cubic-bezier(0.16,1,0.3,1)] motion-reduce:transition-none" style={{
            transform: `translateY(-${rolled ? digit_0 : "0"}em)`
          }}>{DIGITS.map(_temp)}</span></span>;
      };
      $[12] = rolled;
      $[13] = t6;
    } else {
      t6 = $[13];
    }
    t2 = <span className={t4}>{t5}{columns.map(t6)}</span>;
    $[2] = className;
    $[3] = count;
    $[4] = rolled;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
function _temp(option) {
  return <span key={option} className="block h-[1em]">{option}</span>;
}